import React, { useCallback, useState, useEffect } from 'react';
import ReactFlow, { addEdge, applyEdgeChanges, applyNodeChanges, MiniMap, onNodeClick } from 'reactflow';
import { useDrop } from 'react-dnd';
import { Paper, Typography } from '@mui/material'; // Import Material-UI components
import 'reactflow/dist/style.css';

const initialNodes = [];

const initialEdges = [];

function FlowChart({ toggleSidebar, transformData, visualizationData, setVisualizationData, setSelectedWidget, modelInputData, setModelInputData, sheetData, setTransformData, nodeId, setNodeId }) {
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);


  useEffect(() => {
    if (sheetData && nodeId) {
      setNodes((prevNodes) => {
        return prevNodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                sourceData: sheetData, // Add the sourcedata attribute to the node
              },
            };
          }
          return node;
        });
      });
    }
  }, [sheetData, nodeId]);

  useEffect(() => {
    if (transformData && nodeId) {
      setNodes((prevNodes) => {
        return prevNodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                fetchedData: transformData, // Add the sourcedata attribute to the node
              },
            };
          }
          return node;
        });
      });
    }
  }, [transformData, nodeId]);

  useEffect(() => {
    //This is for the model node
    if (visualizationData && nodeId) {
      setNodes((prevNodes) => {
        return prevNodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              data: {
                ...node.data,
                visualizationData: visualizationData, // Add the sourcedata attribute to the node
              },
            };
          }
          return node;
        });
      });
    }
  }, [visualizationData, nodeId]);


  useEffect(() => {
    if (sheetData) {
      console.log(sheetData)
    }
  }, [sheetData]);   // Trigger when sheetData changes


  const fetchSheetData = async () => {
    return sheetData
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes]
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges]
  );

  const onConnect = useCallback(
    async (connection) => {
      setEdges((eds) => addEdge(connection, eds));

      // Find the source node and target node based on the connection information
      const sourceNode = nodes.find(node => node.id === connection.source);
      const targetNode = nodes.find(node => node.id === connection.target);

      console.log("Came here")
      console.log(sourceNode)

      if (sourceNode && targetNode) {
        if (sourceNode.data.label === 'Data Source' && sourceNode.data.sourceData) {
          // Fetch your data based on the source node
          // const data = await fetchSheetData();

          // For clarity, I'm getting sourceData from the source node
          const dataFromSourceNode = sourceNode.data.sourceData;

          console.log(dataFromSourceNode)
          console.log(targetNode.data.label)
          // Update the target node's fetchedData attribute with the source node's sourceData
          setNodes((prevNodes) => {
            return prevNodes.map((node) => {
              if (node.id === targetNode.id) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    fetchedData: dataFromSourceNode,
                  },
                };
              }
              return node;
            });
          });

          setTransformData(dataFromSourceNode)
        }

        // Handling the case where the source node is 'Transform'
        if (sourceNode.data.label === 'Transform') {
          console.log(sourceNode.data.fetchedData)
          console.log(targetNode.data.label)
          setNodes((prevNodes) => {
            return prevNodes.map((node) => {
              if (node.id === targetNode.id) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    inputData: sourceNode.data.fetchedData,
                  },
                };
              }
              return node;
            });
          });
          setModelInputData(sourceNode.data.fetchedData)
        }

        if (sourceNode.data.label === 'Visualization') {
          console.log(sourceNode.data.visualizationData)
          console.log(targetNode.data.label)
          setNodes((prevNodes) => {
            return prevNodes.map((node) => {
              if (node.id === targetNode.id) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    visualizationData: sourceNode.data.visualizationData,
                  },
                };
              }
              return node;
            });
          });
          setModelInputData(sourceNode.data.visualizationData)
        }
      }
    },
    [setEdges, nodes]
  );



  const [, ref] = useDrop({
    accept: 'WIDGET',
    drop: (item, monitor) => {
      const didDrop = monitor.didDrop();
      if (didDrop) {
        return;
      }
      // Add the new node when a widget is dropped
      addNode(item.name);
    }
  });

  const addNode = (name) => {
    console.log(edges)
    console.log('added');
    // Generate unique ID for the node and position it at the center

    const newNode = {
      id: `${name}-node-${nodes.length + 1}`,
      data: { label: name },
      position: { x: 250, y: 250 },
    };

    setNodes((prev) => [...prev, newNode]);
    setNodeId(newNode.id)
    // Pass the selected widget type to the BizzFlow component
    setSelectedWidget(name); // Call the setSelectedWidget function
    toggleSidebar(true)
  };



  const handleNodeClick = (event, node) => {
    // You can perform any action you want when a node is clicked here
    console.log(node.data)
    if (node.data.label === 'Transform') {
      setTransformData(node.data.fetchedData)
    }
    setNodeId(node.id)
    setSelectedWidget(node.data.label);
    toggleSidebar()

    console.log(node.data.fetchedData)
  };


  return (
    <Paper ref={ref} style={{ width: '100%', height: '100%', padding: '10px', overflow: 'auto' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        onNodeClick={handleNodeClick}
      >
        <MiniMap nodeStrokeWidth={3} zoomable pannable />
      </ReactFlow>
    </Paper>
  );
}

export default FlowChart;
